<script setup>
import AppHeader from './components/AppHeader.vue'
import AppSidebar from './components/AppSidebar.vue'
import AppFooter from './components/AppFooter.vue'
import PageMenu from './components/PageMenu.vue'
import PopularGames from './components/PopularGames.vue'
import PromoBanner from './components/PromoBanner.vue'
import TopGames from './components/TopGames.vue'
import TopLiveCasino from './components/TopLiveCasino.vue'
import TopProviders from './components/TopProviders.vue'
import WinnersNow from './components/WinnersNow.vue'

const banners = [
  {
    title: 'Welcome Bonus 333',
    offer: '100% up to €500 +200 FS',
    buttonText: 'Join now',
    image: 'banners/banner-1.png',
    imageAlt: 'Slot machine with casino chips',
  },
]

const lowerPromoBanner = {
  title: 'Welcome Bonus 333',
  offer: '100% up to €500 +200 FS',
  buttonText: 'Join now',
  image: 'banners/banner-2.png',
  imageAlt: 'Casino promotion with bonus offer',
}

const providersPromoBanner = {
  title: 'Welcome Bonus 333',
  offer: '100% up to €500 +200 FS',
  buttonText: 'Join now',
  image: 'banners/banner-3.png',
  imageAlt: 'Casino promotion with bonus offer',
}

const popularPromoBanner = {
  title: 'Welcome Bonus 333',
  offer: '100% up to €500 +200 FS',
  buttonText: 'Join now',
  image: 'banners/banner-4.png',
  imageAlt: 'Casino promotion with bonus offer',
}
</script>

<template>
  <div class="app-layout">
    <AppHeader />
    <AppSidebar />

    <main class="page" aria-label="Page content">
      <PromoBanner
        v-for="banner in banners"
        :key="banner.image"
        :title="banner.title"
        :offer="banner.offer"
        :button-text="banner.buttonText"
        :image="banner.image"
        :image-alt="banner.imageAlt"
      />
      <PageMenu />
      <WinnersNow />
      <TopGames />
      <TopLiveCasino />
      <PromoBanner
        :title="lowerPromoBanner.title"
        :offer="lowerPromoBanner.offer"
        :button-text="lowerPromoBanner.buttonText"
        :image="lowerPromoBanner.image"
        :image-alt="lowerPromoBanner.imageAlt"
      />
      <TopProviders />
      <PromoBanner
        :title="providersPromoBanner.title"
        :offer="providersPromoBanner.offer"
        :button-text="providersPromoBanner.buttonText"
        :image="providersPromoBanner.image"
        :image-alt="providersPromoBanner.imageAlt"
      />
      <PopularGames />
      <PromoBanner
        :title="popularPromoBanner.title"
        :offer="popularPromoBanner.offer"
        :button-text="popularPromoBanner.buttonText"
        :image="popularPromoBanner.image"
        :image-alt="popularPromoBanner.imageAlt"
      />
    </main>

    <AppFooter />
  </div>
</template>
